import { useMemo, useContext } from 'react';
import { useGroupFeatures } from '@trinity/chat-components/containers/Chat/hooks.js';
import { useDevice } from '@trinity/chat-components/hooks';
import { CanUploadFilesContext } from '@trinity/chat-components/containers/WorkspaceFileUpload/Context.js';

export const useCanUpload = () => {
  const canUpload = useContext(CanUploadFilesContext);
  const features = useGroupFeatures();
  const uploadFilesEnabled = features.uploadFiles;

  const device = useDevice();
  return useMemo(() => canUpload && uploadFilesEnabled && !device.phone && !device.tablet, [canUpload, device, uploadFilesEnabled]);
};